// extracted by mini-css-extract-plugin
export default {"close":"floating-button_close__EYrLT","draggable":"floating-button_draggable__VEgLX"};